// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"125":"94b468d4","173":"6e903803"}[chunkId] + ".chunk.js";
};